export interface IMap<T> {
	get(key: string): T | undefined;
	set(key: string, value: T): void;
	has(key: string): boolean;
	keys(): string[];
	values(): T[];
	clear(): void;
	delete(key: string): void;
	size: number;
}

/**
 * Simple map implementation that is the same as native Map.
 */
export class IkeMap<T> implements IMap<T> {
	_values: { [key: string]: T } = {};

	get(key: string): T | undefined {
		return this._values[key];
	}
	set(key: string, value: T) {
		this._values[key] = value;
	}
	has(key: string): boolean {
		return this._values[key] != null;
	}
	keys(): string[] {
		return Object.keys(this._values);
	}
	values(): T[] {
		const keys = Object.keys(this._values);
		const output: T[] = [];
		for (const key of keys) {
			output.push(this._values[key]!);
		}
		return output;
	}
	clear() {
		this._values = {};
	}
	delete(key: string) {
		delete this._values[key];
	}
	get size(): number {
		return this.keys().length;
	}
}
